// URL canônica do site, usada em links de e-mail (confirmação, recuperação, convites).
// Nunca usar window.location.origin nesses casos: em preview/domínio temporário
// os e-mails acabam apontando para o link errado.
export const SITE_URL = 'https://bianchimbusiness.com.br';
